
// Utility to split text into sentences using Intl.Segmenter
export interface TextChunk {
    text: string;
    index: number; // Index in the original array (if applicable) or sequence
    offset: number; // Character offset in original string
}

export function segmentText(text: string): string[] {
    if (!text) return [];

    // Polyfill-ish fallback
    if (typeof Intl === 'undefined' || !Intl.Segmenter) {
        return text.match(/[^.!?]+[.!?]+[\])'"]*|.+/g) || [text];
    }

    const segmenter = new Intl.Segmenter('en', { granularity: 'sentence' });
    const segments = segmenter.segment(text);
    return Array.from(segments).map(s => s.segment);
}

// Helper to flatten an array of paragraphs into sentences
// Returns flat array of sentences, but we might want to map them back to paragraphs?
// Actually simpler: Flatten the whole page content into a single sequence of sentences for TTS.
export function segmentPageContent(paragraphs: string[]): string[] {
    const allSentences: string[] = [];
    for (const para of paragraphs) {
        const sentences = segmentText(para);
        allSentences.push(...sentences);
    }
    return allSentences;
}
